/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Domain, Domain$inboundSchema } from "./domain.js";
import { Meta, Meta$inboundSchema } from "./meta.js";
import { Pagination, Pagination$inboundSchema } from "./pagination.js";

export type V1DomainsListDomainsResponseBody = {
  /**
   * Metadata object included in every API response. This provides context about the request and is essential for debugging, audit trails, and support inquiries. The `requestId` is particularly important when troubleshooting issues with the Teral support team.
   */
  meta: Meta;
  /**
   * Domains that match every request filter and that you have permission to read, sorted by ID.
   *
   * @remarks
   * The array is empty when no readable domains match, including when a filtered resource
   * is missing or mismatched.
   */
  data: Array<Domain>;
  /**
   * Pagination metadata for list endpoints. Provides information necessary to traverse through large result sets efficiently using cursor-based pagination.
   */
  pagination: Pagination;
};

/** @internal */
export const V1DomainsListDomainsResponseBody$inboundSchema: z.ZodType<
  V1DomainsListDomainsResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  meta: Meta$inboundSchema,
  data: z.array(Domain$inboundSchema),
  pagination: Pagination$inboundSchema,
});

export function v1DomainsListDomainsResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<V1DomainsListDomainsResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => V1DomainsListDomainsResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'V1DomainsListDomainsResponseBody' from JSON`,
  );
}
